import {onLoad} from "../base/onLoad";

onLoad(() => {
    const rootStyles = getComputedStyle(document.documentElement);
    const color = rootStyles.getPropertyValue('--primary-color');
    const title = document.querySelector('.fade_header .title');
    let changeTitleColor = false;

    if (color) {
        const colorRGB = hexToRgb(color);
        if (colorRGB !== null) {
            if (calculateContrast(colorRGB) < 2) {
                changeTitleColor = true;
                document.querySelector('header')?.classList.add('contrast');
            }
        }
    }

    if (changeTitleColor) {
        title?.classList.add('dark')
    }
});

function hexToRgb(hex: string): [number, number, number] | null {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? [
            parseInt(result[1], 16),
            parseInt(result[2], 16),
            parseInt(result[3], 16)
        ]
        : null;
}

function calculateRelativeLuminance(rgb: [number, number, number]): number {
    const [r, g, b] = rgb.map(value => {
        const sRGBValue = value / 255;
        return sRGBValue <= 0.03928 ? sRGBValue / 12.92 : Math.pow((sRGBValue + 0.055) / 1.055, 2.4);
    });

    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

function calculateContrast(color1: [number, number, number]): number {
    const luminance1 = calculateRelativeLuminance(color1);
    const luminanceWhite = calculateRelativeLuminance([255, 255, 255]);

    return (Math.max(luminance1, luminanceWhite) + 0.05) / (Math.min(luminance1, luminanceWhite) + 0.05);
}
